<script>
export default {
  name: 'rekonoAlerts',
  methods: {
    alert (title, body, variant) {
      const duration = variant === 'danger' ? 8000 : 5000
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        autoHideDelay: duration,
        appendToast: false
      })
    },
    success (title, body) {
      this.alert(title, body, 'success')
    },
    warning (title, body) {
      this.alert(title, body, 'warning')
    },
    danger (title, body) {
      this.alert(title, body, 'danger')
    },
    info (title, body) {
      this.alert(title, body, 'info')
    }
  }
}
</script>